import { useNavigate } from "react-router-dom"
import { useInView } from "react-intersection-observer"
import type { GalleryListResponse } from "@/service/api/gallery"

interface Props {
  galleryListData?: GalleryListResponse
}
const GalleryGridOne = ({ galleryListData }: Props) => {
  const navigate = useNavigate()
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  return (
    <div className="px-4 grid grid-flow-col grid-rows-2 gap-0.5 h-[204px]">
      {galleryListData?.content.map((item, idx) => {
        const baseClass = "overflow-hidden"

        if (idx === 0) {
          return (
            <button
              onClick={() => {
                navigate(`gallery/${item.id}`, {
                  state: { galleryList: galleryListData.content },
                })
              }}
              key={item.id}
              className={`${baseClass} row-span-2 col-span-2 rounded-xl`}
              ref={ref}
            >
              {inView && (
                <img
                  src={item.imageUrl}
                  alt="Image"
                  className="object-cover w-full h-full"
                />
              )}
            </button>
          )
        }

        return null
      })}
    </div>
  )
}

export default GalleryGridOne
